import { matchPattern } from '../../../core/utils/string';
import { GlobalSearchStateItem, GlobalSearchState, GlobalSearchFilters } from '../../interfaces/global-search';

function getFilteredEntities(
  entityData: GlobalSearchStateItem,
  filters: GlobalSearchFilters
) {
  const {
    inMemoryFiltering,
    maxItemsWhenFiltersApplied,
    maxItemsWhenNoFiltersApplied
  } = entityData.metaData;

  if ((!filters.search && filters.entity.length === 0)) {
    return [...entityData.entities].slice(0, maxItemsWhenNoFiltersApplied);
  }

  if (!inMemoryFiltering) {
    return [...entityData.entities].slice(
      0, maxItemsWhenFiltersApplied || entityData.entities.length
    );
  }

  const filteredEntities = entityData.entities.filter(
    data => matchPattern(data.searchKeywords, filters.search)
  );

  const maxItems = maxItemsWhenFiltersApplied || filteredEntities.length;

  return filteredEntities.slice(0, maxItems);
}

export function filterGlobalSearchEntityData(
  entity: string,
  state: GlobalSearchState
): GlobalSearchStateItem {
  const { search } = state.filters;
  const entityData = state.items[entity];

  if (!search && state.filters.entity.length === 0) {
    return {
      ...entityData,
      filteredEntities: entityData.entities.slice(0, entityData.metaData.maxItemsWhenNoFiltersApplied)
    };
  }

  const filteredEntities = getFilteredEntities(entityData, state.filters);

  return {
    ...entityData,
    filteredEntities
  };
}

export function filterStateData(state: GlobalSearchState) {
  const filteredEntities = Object.keys(state.items).reduce((acc, curr) => ({
      ...acc,
      [curr]: {
        ...state.items[curr],
        filteredEntities: getFilteredEntities(state.items[curr], state.filters)
      }
    }), {});

  return {
    ...filteredEntities
  };
}
